import { defineStaticService, implementStaticService } from '@wix/static-service'
import type { StaticServiceDefinition, StaticServiceFactoryOpts } from '@wix/static-service'
import { createStyleUtils } from './compStylesOverridesService'
import { StyleUtilsConfig, StyleUtils } from './types'

export type IStyleUtilsDefinition = StaticServiceDefinition<styleutils, StyleUtilsConfig="">

export const StyleUtilsDefinition = defineStaticService<styleutils, StyleUtilsConfig="">('viewer-core/style-utils')

export const StyleUtilsService = implementStaticService(
	StyleUtilsDefinition,
	({ config }: StaticServiceFactoryOpts<styleutilsconfig>) => createStyleUtils(config)
)
</styleutilsconfig></styleutils,></styleutils,>